import React from 'react';

import {FormSection} from 'iss/widgets/Forms';

export function ConditionalFormSection({showWhen, children, ...props}) {
  return <FormSection>
    {(values) =>
        showWhen(values) && <FormSection {...props}>{children}</FormSection>}
  </FormSection>;
}



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/form/ConditionalFormSection.jsx